import * as Yup from 'yup'

export const EditContractorFileExpirationDateSchema = Yup.object().shape({
  expiresAt: Yup.string().required('This field is required'),
})
